import { render } from "./Section3Filter.vue?vue&type=template&id=0553823d&scoped=true&ts=true"
import script from "./Section3Filter.vue?vue&type=script&lang=ts"
export * from "./Section3Filter.vue?vue&type=script&lang=ts"

import "./Section3Filter.vue?vue&type=style&index=0&id=0553823d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0553823d"]])

export default __exports__